import React from 'react';
import Component from '../../../Component';
import Styles from './styles';
import { path } from '../../../../utils';
import view from '../../../../Enums';
import * as GlobalActions from '../../../../reducers/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Popper from '@material-ui/core/Popper/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener/ClickAwayListener';
import Grow from '@material-ui/core/Grow/Grow';
import RevenueMigrationWrapper from '../RevenueMigrationWrapper';
import { withTranslations } from '../../../../HoCs';

class RevenuePopper extends Component {
    
    styles=Styles;
    
    state = {
        popperOpen: false,
        popperAnchor: null,
    };
    
    childGetStyle = key => path(this.styles, `${key}.${this.getViewMode()}`, path(this.styles,`${key}.${view.MOBILE}`,{}));
    
    openPopper = e => this.setState({ popperOpen: true, popperAnchor: e.currentTarget });
    closePopper = () => {
        this.setState({
            popperOpen: false, popperAnchor: null
        })
    };
    
    render() {
        return (
            <>
                <div onClick={this.openPopper} style={this.gs('earning')}>{this.guc('how_much_can')}{'?'}</div>
                <Popper open={this.state.popperOpen} anchorEl={this.state.popperAnchor} transition style={this.gs('popper')}>
                    {({ TransitionProps }) => <ClickAwayListener onClickAway={this.closePopper}>
                        <div>
                            <Grow {...TransitionProps} timeout={50} style={{ transformOrigin: '50% 0%' }}>
                                <RevenueMigrationWrapper/>
                            </Grow>
                        </div>
                    </ClickAwayListener>}
                </Popper>
            </>
        );
    }
}


const mapDispatchToProps = dispatch => {
    return {
        globalActions: bindActionCreators(GlobalActions, dispatch)
    };
};

const mapStateToProps = state => {
    return {
        globalData: state.globalReducer
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(withTranslations(RevenuePopper));